import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const CustomTooltip = ({ text, children }) => {
  const renderTooltip = (props) => <Tooltip id="tooltip">{props}</Tooltip>;

  return (
    <OverlayTrigger placement="top" overlay={renderTooltip(text)}>
      {children}
    </OverlayTrigger>
  );
};

export default CustomTooltip;
